import React from 'react';
import { useTasks } from '../../contexts/TaskContext';
import { useAuth } from '../../hooks/useAuth';
import LoadingSpinner from '../common/LoadingSpinner';
import TaskForm from '../tasks/TaskForm';
import TaskList from '../tasks/TaskList';

const TaskManager = () => {
  const { currentUser } = useAuth();
  const { tasks, loading, error, setError } = useTasks();

  // Show loading if no user yet
  if (!currentUser) {
    return (
      <div className="max-w-6xl mx-auto px-6 py-8">
        <LoadingSpinner message="Please sign in to view your tasks..." />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="max-w-6xl mx-auto px-6 py-8">
        <LoadingSpinner message="Loading your tasks..." />
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-6 py-8">
      {/* Error display */}
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6 flex items-center justify-between">
          <span>{error}</span>
          <button onClick={() => setError(null)} className="ml-4 text-red-500">×</button>
        </div>
      )}

      {/* Quick stats in header */}
      <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <h1 className="text-xl font-semibold">Task Manager</h1>
          <div className="flex flex-wrap gap-2 text-sm">
            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full">
              {tasks.length} Total
            </span>
            <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full">
              {tasks.filter(t => t.completed).length} Done
            </span>
            <span className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full">
              {tasks.filter(t => !t.completed).length} Pending
            </span>
          </div>
        </div>
      </div>

      {/* Task Form */}
      <TaskForm />

      {/* Task List */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h2 className="text-lg font-semibold mb-4">
          All Tasks ({tasks.length}) - Most Recent First
        </h2>
        
        <TaskList tasks={tasks} showTimestamps={true} />
      </div>
    </div>
  );
};

export default TaskManager;